import { render, staticRenderFns } from "./MessageManagement.vue?vue&type=template&id=76f5f38a&scoped=true&"
import script from "./MessageManagement.vue?vue&type=script&lang=js&"
export * from "./MessageManagement.vue?vue&type=script&lang=js&"
import style0 from "./MessageManagement.vue?vue&type=style&index=0&id=76f5f38a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f5f38a",
  null
  
)

export default component.exports